import { pipe } from "fp";

import { creator, reducer, type } from "~/Action/Definition";
import * as Document from "~/Document";

export namespace Updated {
  export const { TYPE, create, reduce } = pipe(
    type("Active Document Updated" as const),
    creator((document: Document.Active.Active) => ({ document })),
    reducer(({ state, action: { document } }) => {
      state.documents.active = document as typeof state.documents.active;
    })
  );
}

export namespace Cleared {
  export const { TYPE, create, reduce } = pipe(
    type("Active Document Cleared" as const),
    reducer(({ state }) => {
      state.documents.active = undefined;
    })
  );
}
